<template>
  <div class="flex flex-wrap justify-center p2 px3">
    <WalletInformation :wallet="wallet" />

    <div class="col-12 md-col-8 flex flex-wrap justify-center pt3">
      <div class="col-12 flex justify-center">
        <Alert v-if="alert" class="mb2" :message="alert.message" :icon="alert.icon" :color="alert.color" />
      </div>

      <div class="col-12 md-col-6 relative mt2">
        <input v-model="email" class="input-field col-12 px2" :class="alert ? `alert-${alert.color}-border` : '' " type="text" style="height:55px; font-size:15px;" :placeholder="getReferencelabel('ENTER_RECIPIENT_EMAIL')">
        <i class="icon-at icon-input"></i>
      </div>

      <Button reference="SEND" class="col-12 md-col-4 center pl0 md-pl1 mt2" btn-color="blue" :action="share" />
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Button from '@/components/elements/Button';
import WalletInformation from '@/components/services/WalletInformation';
import Alert from '@/components/common/Alert';

import { shareQRcode } from '@/mixins/requests';

import { matchExact, getReferencelabel } from '@/mixins/utils';

export default {
  components: {
    Button,
    WalletInformation,
    Alert
  },
  setup () {
    const route = useRoute();
    const store = useStore();
    const wallet = store.state.wallets.find(a => a.uuid === route.params.id);
    const email = ref('');
    const alert = ref(null);

    function share () {
      const validation = !matchExact(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/, email.value) ? 'ERROR_WRONG_EMAIL' : false;

      if (validation && validation.length) {
        alert.value = {
          message: validation,
          color: 'error',
          icon: 'attention'
        };
        return;
      }

      shareQRcode(email.value, wallet.uuid, store.getters.getLanguage);
      email.value = '';
      alert.value = {
        message: 'QRCODE_SAHRE_SUCCESS',
        color: 'success',
        icon: 'check'

      };
    }

    return { wallet, share, email, alert, getReferencelabel };
  }
};
</script>

<style>
.alert-success-border{
  border: 1px solid green;
}

.alert-error-border{
  border: 1px solid red;
}
.image-border {
  border: 1px solid black;
  height:50px; width:50px;
  border-radius:50%;
}

</style>
